<template>
  <el-dialog
    title="选择班次"
    :visible.sync="dialogVisible"
    width="700px">
    <div>
      <div style="margin-bottom: 40px;">
        <el-row :gutter="24">
          <el-col :span="20">
            <div style="display: flex;">
              <el-input v-model="where.project_name" size="mini" placeholder="项目" @focus="selectDepartmentShow"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24" style="margin-top: 10px">
          <el-col :span="20">
            <div style="display: flex;">
              <el-input v-model="where.keyword" size="mini" placeholder="班次名称"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="display: flex;">
              <el-button size="mini" type="primary" @click="searchs">查询</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="pageData.list"
          :default-sort = "{}"
          border
          style="width: 100%"
          height="400px">
          <el-table-column prop="class_name" label="班次"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="confirmFun(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
<!--      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>-->
    </div>
    <select-department ref="selectDepartment" />
  </el-dialog>
</template>

<script>
import Http from "../common/Http";
import SelectDepartment from "../../Personnel/components/selectDepartment";
export default {
  name: "SelectWorkClass",
  components:{SelectDepartment},
  data(){
    return {
      dialogVisible:false,
      loading:false,
      where:{
        keyword:'',
        project_id:0,
        project_name:'',
      },
      pageData:{
        list:[],
      },
      callback_fun:undefined,
    }
  },
  mounted() {
    // this.getUserRoleList()
  },
  methods:{
    initConfig(){
      this.where = {
        keyword:'',
        project_id:0,
        project_name:'',
      }
      this.pageData = {
        list:[],
      };
      this.callback_fun=undefined;
    },
    /**
     * 显示流程
     */
    show(config,callback_fun){
      const that = this;
      that.initConfig();
      that.where = config;

      that.dialogVisible=true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
      that.getList();
    },
    confirmFun(item){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(item);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    getList() {
      const that = this;
      that.loading=true;
      let params = that.where;
      params.page_size = 10000
      params.status = 1
      if (that.where.project_id > 0) {
        params.department = [{id: that.where.project_id}]
      }
      Http.get("hrm/UserWorkClass/search",params,res=>{
        if(res.code == 0) {
          that.pageData.list = res.data
        }
        that.loading=false;
      })
    },
    searchs() {
      this.getList()
    },
    selectDepartmentShow() {
      let that = this
      this.$refs.selectDepartment.show({},data=>{
        that.$set(that.where, 'project_id', data.id)
        that.$set(that.where, 'project_name', data.ancestor_name)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectWorkClass.vue